module.exports = __webpack_public_path__ + "img/selected3-min.622c8971.png";